import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ParametroAccionService } from 'src/app/Services/parametro-accion.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-empresa-form',
  templateUrl: './empresa-form.component.html',
  styleUrls: ['./empresa-form.component.css']
})
export class EmpresaFormComponent implements OnInit {

  formulario: FormGroup;
  private insertaEmpr:string = environment.insempr;
  private lovs:string = environment.lovs;

  params: any;
  
  comunasLov: any[] = [];
  ciudadesLov: any[] = [];
  tiposHonorariosLov: any[] = [];
  regionesLov: any[] = [];

  constructor(private http: HttpClient, private fb: FormBuilder, public parametroAccionService:ParametroAccionService) {
    
    this.formulario = this.fb.group({
      rut: [''],
      dv: [''],
      razonSocial: [''],
      calle: [''],
      nro:[''],
      nroDepto:[''],
      comuna:[''],
      ciudad:[''],
      region:[''],
      correo:[''],
      correoCon:[''],
      fonoArea:[''],
      fono:[''],
      celuArea:[''],
      celu:[''],
      tipoHonorario:['']
    });

    let hayParam: boolean = false;

    this.params = this.parametroAccionService.obtenerDatos();
    if (this.params) {
      this.formulario.patchValue(this.params);
      hayParam=true;
    }
    if(hayParam){
      this.formulario.get('rut').disable();
      this.formulario.get('dv').disable(); 
    }
    this.parametroAccionService.limpiarDatos();
   }

  ngOnInit(): void {
    //obtengo listas de valores:
    // 1.- Regiones
    // 2.- Ciudades (con cdg región)
    // 3.- Comunas (con cdg región)
    // 4.- Tipos Honorarios
    this.http.post<any>(this.lovs, { 
      codigo_lista:1,
      codigo_region:0,
    }).subscribe((data:any) => {
      //console.log(data);
      //console.log(data.Resultado);
      this.regionesLov = data.Resultado;
    }, err => {
      console.log("error capturado");
      console.log(err);
    });

    /*this.http.post<any>(this.lovs, { 
      codigo_lista:4,
      codigo_region:0,
    }).subscribe((data:any) => {
      this.tiposHonorariosLov = data.Resultado;
    }, err => {
      console.log("error capturado");
      console.log(err);
    });*/
    this.formulario.get('region')?.valueChanges.subscribe((selectedRegion) => {
      this.obtenerCiudades(selectedRegion);
      this.obtenerComunas(selectedRegion);
    });
  }

  obtenerCiudades(selectedRegion: number): void {
    // Realiza la llamada al servicio HTTP para obtener provincias
    this.http.post<any>(this.lovs, { 
      codigo_lista: 3,
      codigo_region: selectedRegion,
    }).subscribe((data: any) => {
      //console.log(data);
      //console.log(data.Resultado);
      this.ciudadesLov = data.Resultado;
    }, err => {
      console.log("error capturado");
      console.log(err);
    });
  }

  obtenerComunas(selectedRegion: number): void {
    // Realiza la llamada al servicio HTTP para obtener provincias
    this.http.post<any>(this.lovs, { 
      codigo_lista: 2,
      codigo_region: selectedRegion,
    }).subscribe((data: any) => {
      //console.log(data);
      //console.log(data.Resultado);
      this.comunasLov = data.Resultado;
    }, err => {
      console.log("error capturado");
      console.log(err);
    });
  }



  inserteEmpr(){
    this.http.post<any>(this.insertaEmpr, { 
      rut_empresa:this.formulario.get('rut').value,
      dv_empresa:this.formulario.get('dv').value,
      rzn_social:this.formulario.get('razonSocial').value,
      estado_empresa:"1",
      calle:this.formulario.get('calle').value,
      numero:this.formulario.get('nro').value,
      nmr_dpto:this.formulario.get('nroDepto').value,
      cmns_cdg:this.formulario.get('comuna').value,
      cdds_cdg:this.formulario.get('ciudad').value,
      rgns_cdg:this.formulario.get('region').value,
      correo_electronico:this.formulario.get('correo').value,
      fono_area_cdg:this.formulario.get('fonoArea').value,
      fono_numero:this.formulario.get('fono').value,
      celu_area_cdg:this.formulario.get('celuArea').value,
      celu_numero:this.formulario.get('celu').value,
      tipo_honorario:this.formulario.get('tipoHonorario').value,
      user:"user"
    }).subscribe((data:any) => {
      console.log(data.resultado);
      //this.result = data.resultado;
      //this.rut= data.Rut;
      
    }, err => {
      console.log("error capturado");
      console.log(err);
    });
  }
}
